module.exports = __webpack_public_path__ + "img/icon-differentials2_04.17870d70.svg";